import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { CognitoServiceService } from '../../services/cognito-service.service';
import { FormDefinitionsService } from '../../services/forms/form-definitions.service';
import { CommonService } from 'src/app/services/common/common.service';

@Component({
  selector: 'app-confirm-password',
  templateUrl: './confirm-password.component.html',
  styleUrls: ['./confirm-password.component.scss']
})
export class ConfirmPasswordComponent implements OnInit {

  vua: any;
  confirmPwdForm: any;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private cognito: CognitoServiceService,
    private formDefinitionsService: FormDefinitionsService,
    private commonService: CommonService
  ) { }

  ngOnInit() {
    this.confirmPwdForm = this.formDefinitionsService.confirmPwdForm;

    // Subscribing to query params to get username.
    this.route.queryParams.subscribe((queryParams:any) => {
      this.vua = queryParams.vua;
    });
  }


  /**
   * @desc To confirm the user who forgot password for a particular usename
   * @param  {Object} event
   */
  confirmPassword(event) {
    let form = event.formData;

    let confirmationCode = form.controls.confirmationCode.value; 
    let newPassword = form.controls.newPassword.value;
    this.cognito.confirmPassword(this.vua, confirmationCode, newPassword, (status, error?)=> {
      if(status) {
        form.reset();
        // After successful confirmation and change password, navigating to dashboard.
        this.showGlobalPopup("Password successfully updated.");
        this.router.navigate(['/login']);
      } else {
        // if the password does not satisfy the constraints, asking user to re-enter the password.
        if(error.code == "InvalidPasswordException") {
          this.showGlobalPopup("please enter valid password... a minimum of 1 lower case letter [a-z] and a minimum of 1 upper case letter a minimum of 1 numeric character a minimum of 1 special character.");
        } else if(error.code == "ExpiredCodeException") {
          this.showGlobalPopup("Code expired. Please try after some time...");
        } else {
          this.showGlobalPopup(error.message || JSON.stringify(error));
        }
      }
    });
  }

  /**
   * To build and show global message popup
   * @param body popup body message
   * @param heading popup heading message
   */
  showGlobalPopup(body: string, heading?: string) {
    let popuptext = {
      heading: heading || "OnemoneyAA",
      body: body,
      successCallback: this.popupConfirmed.bind(this),
      cancelCallback: this.closePopup.bind(this)
    }

    this.commonService.showGlobalMessage(popuptext);
  }

  /**
   * To hide Popup, we are changing ngIf to false.
   */
  closePopup() {
    // Popup close
  }

  popupConfirmed(event) {
    // Popup confirm
  }

}
